<template>
    <div class="footer">
        <div class="linksHead">
            <div class="linksLogo">友情链接</div>
        </div>
        <ul>
            <li v-bind:key="index" v-for="(item, index) in footlinks">
                <a class="links" :href="item.href" target="_blank" :title="item.name">
                    <p>{{item.name}}</p>
                </a>
            </li>
        </ul>
        <div class="foot">
            <span>
                Copyright © 2000 - {{currentYear}} Baidu, All Rights Reserved.
            </span>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        const date = new Date();
        const year = date.getFullYear();
        return{
            footlinks:[
                {
                    name: '百度开发者中心',
                    href:'https://developer.baidu.com/',
                    thumUrl: ''
                }
            ],
            currentYear: year
        }
    }
}
</script>
<style lang="less">
.footer{
    margin: 15px auto 0 auto;
    overflow: hidden;
    .linksHead{
        width: 100%;
        height: 36px;
        max-width: 1320px;
        margin: 0 auto;
        .linksLogo{
            color: #043483;
            float: left;
            height: 26px;
            line-height: 26px;
            border: 1px solid #043483;
            border-radius: 18px;
            padding: 0 20px;
        }
    }
    ul{
        overflow: hidden;
        max-width: 1320px;
        margin: 0 auto;
        li{
            width: 15%;
            float: left;
            list-style-type: none;
            overflow: hidden;
            padding-top: 14px;
            padding-bottom: 28px;
            color: #043483;
            a{
                text-decoration-line: none;
                cursor: pointer;
                p{
                    color: #043483;
                }
            }
        }
    }
    .foot{
        width: 100%;
        height: 60px;
        font-size: 14px;
        background-color: #eee;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>




// WEBPACK FOOTER //
// src/common/footer-links/index.vue